module.exports = __webpack_public_path__ + "img/slider.97ae620b.svg";